<template>
    <AppLayout :contrast="true" title="Personalizar Email Global">
        <Toast />
        <Breadcrumb
            page="Personalizar Email Global"
        />
        <form class="p-2">
            <div class="flex flex-col w-full"> 
                <div class="bg-white rounded-lg shadow p-5 m-2 lg:mx-4 lg:max-w-3xl">
                    <div class="">
                        <div class="font-medium text-gray-600 text-lg mb-2">
                            <div class="relative">
                                <input type="text" id="floating_helper" aria-describedby="floating_helper_text" class="block rounded-t-lg px-2.5 pb-2.5 pt-5 w-full text-sm text-gray-900 bg-gray-50 dark:bg-gray-700 border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" ">
                                <label for="floating_helper" class="absolute text-sm text-black-500 dark:text-black-400 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-2.5 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4">Información de Email</label>
                            </div>
                            <p id="floating_helper_text" class="mt-2 text-xs text-red-500 dark:text-red-400">La información cargada en el presente editor sera mostrada por defecto en todos los email.</p>
                        </div>
                        <br>
                        <ckeditor :editor="editor" v-model="form.email" :config="editorConfig"></ckeditor>
                    </div>
                </div>
            </div>
            <div class="m-4 flex justify-end lg:max-w-3xl">
                <Button @click.prevent="actualizar"> Personalizar Email </Button>
            </div>
        </form>
    </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import { Link } from "@inertiajs/inertia-vue3";
import { Icon } from "@vicons/utils";
import { AngleRight } from "@vicons/fa";
import Breadcrumb from "@/shared/Breadcrumb.vue";
import Button from "@/shared/Button.vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditor from "@ckeditor/ckeditor5-vue";

export default {
    components: {
        AppLayout,
        Link,
        Icon,
        AngleRight,
        Button,
        Breadcrumb,
        ckeditor: CKEditor.component,
    },
    props: {
        configuracion: Object,
        
    },
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {
                toolbar: {
                    items: [
                        'heading', '|',
                        'fontfamily', 'fontsize', '|',
                        'alignment', '|',
                        'fontColor', 'fontBackgroundColor', '|',
                        'bold', 'italic', 'strikethrough', 'underline', 'subscript', 'superscript', '|',
                        'link', '|',
                        'outdent', 'indent', '|',
                        'bulletedList', 'numberedList', 'todoList', '|',
                        'code', 'codeBlock', '|',
                        'insertTable', '|',
                        'undo', 'redo'
                    ],
                    shouldNotGroupWhenFull: true
                }
            },
            form: this.$inertia.form({
                email: this.configuracion.email,
            }),
        };
    },
  
    methods: {
        actualizar() {
            this.form.put("/configuraciones/actualizar/" + this.configuracion.id, {
                onSuccess: () => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Exito",
                        detail: "Email Modificado",
                        life: 3000,
                    });
                },
            });
        }
    },
};
</script>

<style scoped>
.p-inputtext:enabled:focus,
.p-password-input:enabled:focus {
    box-shadow: 0 0 0 1px #2e5f98;
    border-color: #2e5f98;
}
.p-inputtext:hover,
.p-password-input:hover {
    border-color: #829fc1;
}
</style>
